import React from "react";
import { supabase } from "../../lib/supabase";

export default function StartupFallback() {
  const handleRefresh = () => {
    window.location.reload();
  };

  const handleResetSession = async () => {
    try {
      await supabase.auth.signOut();
    } catch (error) {
      console.error("[StartupFallback] Supabase sign out failed", error);
    }

    try {
      localStorage.clear();
      sessionStorage.clear();

      if ("indexedDB" in window && indexedDB.databases) {
        const databases = await indexedDB.databases();
        databases.forEach((database) => {
          if (database.name) {
            indexedDB.deleteDatabase(database.name);
          }
        });
      }
    } catch (error) {
      console.error("[StartupFallback] Browser storage clear failed", error);
    }

    window.location.reload();
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-6">
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-6 text-center shadow-sm">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-slate-100">
          <span className="text-xl font-semibold text-slate-900">T</span>
        </div>

        <h1 className="text-lg font-semibold text-slate-900">
          Toren is taking longer than expected to load.
        </h1>

        <p className="mt-3 text-sm leading-6 text-slate-600">
          This can happen when an old browser session or cached app state gets stuck.
          Refreshing usually fixes it. If not, reset the local session and sign in again.
        </p>

        <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:justify-center">
          <button
            type="button"
            onClick={handleRefresh}
            className="rounded-lg bg-slate-900 px-4 py-2 text-sm font-medium text-white hover:bg-slate-800"
          >
            Refresh Toren
          </button>

          <button
            type="button"
            onClick={handleResetSession}
            className="rounded-lg border border-slate-300 px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50"
          >
            Reset session
          </button>
        </div>

        <p className="mt-5 text-xs text-slate-500">
          You may need to sign in again after resetting your session.
        </p>
      </div>
    </div>
  );
}
